// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"style_wrapper__TSMZ8","wrapper-small":"style_wrapper-small__hwiGF","component":"style_component__vvtlf","provider-logo":"style_provider-logo__1Hjz0"};